import { useState } from 'react';
import { Button } from '@london-life/ui/components/button';

// shows recovery codes once, with copy and download; they are never shown again
export function RecoveryCodes({ codes }: { codes: string[] }) {
  const [copied, setCopied] = useState(false);
  const text = `London Life admin recovery codes\nEach code works once. Keep them somewhere safe, such as a password manager.\n\n${codes.join('\n')}\n`;
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
    } catch {
      setCopied(false);
    }
  };
  const download = () => {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(new Blob([text], { type: 'text/plain' }));
    link.download = 'london-life-recovery-codes.txt';
    link.click();
    URL.revokeObjectURL(link.href);
  };
  return (
    <div className="recovery-codes">
      <ol>
        {codes.map((code) => (
          <li key={code}>
            <code>{code}</code>
          </li>
        ))}
      </ol>
      <div className="admin-page-actions">
        <Button type="button" variant="outline" onClick={() => void copy()}>
          {copied ? 'Copied' : 'Copy codes'}
        </Button>
        <Button type="button" variant="outline" onClick={download}>
          Download as a file
        </Button>
      </div>
    </div>
  );
}
